var $69ba655c7853c08e$exports = {};
$69ba655c7853c08e$exports = {
  "buttonLabel": "Visa f\xF6rslag",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " alternativ");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " alternativ");
      }
    }), " tillg\xE4ngliga.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Ingick i gruppen ".concat(args.groupTitle, " med ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " alternativ");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " alternativ");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", valda",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "F\xF6rslag",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", valda");
  }
};
export { $69ba655c7853c08e$exports as default };